import * as React from 'react';
import 'azure-devops-ui/Core/override.css';
import './app.scss';
import MainView from './views/MainView';
import { AppToastProvider } from './services/appToast.service';
import WorkItemServiceForWebApp from './services/workItem.service';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AuthProvider from '../common/hooks/workosAuthProvider';
import { applyTheme } from 'azure-devops-extension-sdk';
import { themeData } from './darkTheme';
import ProjectContextProviderForWebApp from './services/projectContext.service';
import { ISettingsContext, SettingsContext } from '../common/hooks/useSettings';
import { ToastContext } from '../common/hooks/useToast';
import { WorkItemManagerContext } from '../common/hooks/useWorkItemManager';
import ProjectSettingsView from './views/ProjectSettingsView';
import { ProjectContextProviderContext } from '../common/hooks/useProjectContextProviderContext';
import ContentView from './views/ContentView';
import ReactGA from 'react-ga4';
import { TeachingService } from './services/teach.service';
import Teach from './components/Teach';
import { CachingServiceContext } from '../common/hooks/useCachingService';
import { CachingService } from '../common/services/caching.service';
import { ProfileServiceContext } from '../common/hooks/useProfileService';
import { ProfileService } from '../common/services/profile.service';

const App = () => {
  applyTheme(themeData.data);
  const workItemManager = new WorkItemServiceForWebApp();
  const projectContextProvider = new ProjectContextProviderForWebApp();
  const toastProvider = new AppToastProvider();
  const teachingService = new TeachingService();
  const settings = {
    displayApplySuggestionsButton: false,
    useSessionStorage: false,
    isWebApp: true,
  } as ISettingsContext;
  const cachingService = new CachingService(workItemManager);
  const config = require('./config.json');
  ReactGA.initialize(config.GoogleAnalyticsMeasurementId);

  const ProviderWrapper = ({ children }) => {
    return (
      <SettingsContext.Provider value={settings}>
        <ToastContext.Provider value={toastProvider}>
          <WorkItemManagerContext.Provider value={workItemManager}>
            <ProjectContextProviderContext.Provider value={projectContextProvider}>
              <Teach teachingService={teachingService}>
                <CachingServiceContext.Provider value={cachingService}>
                  <AuthProvider clientId={config.WorkOSClientId}>{children}</AuthProvider>
                </CachingServiceContext.Provider>
              </Teach>
            </ProjectContextProviderContext.Provider>
          </WorkItemManagerContext.Provider>
        </ToastContext.Provider>
      </SettingsContext.Provider>
    );
  };

  const WrappedMainViewComponent = () => {
    return (
      <ProviderWrapper>
        <MainView />
      </ProviderWrapper>
    );
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<WrappedMainViewComponent />}>
          <Route index element={<ContentView />} />
          <Route path=':sampleId' element={<ContentView />} />
          <Route path=':sampleId/settings' element={<ProjectSettingsView />} />
          <Route path='settings' element={<ProjectSettingsView />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
